import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }

import { computed } from 'vue'
import TableItemCount from '@/components/Common/TableItemCount.vue';

type Props = {
  modelValue: number,
  totalPage: number,
  itemsPerPage?: number,
  allElementsCount?: number,
  showItemCount?: boolean,
}

export default /*@__PURE__*/_defineComponent({
  __name: 'PaginateWithCount',
  props: {
    modelValue: {},
    totalPage: {},
    itemsPerPage: { default: 0 },
    allElementsCount: { default: 0 },
    showItemCount: { type: Boolean, default: false }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit

const page = computed({
  get: () => props.modelValue,
  set: (value: number) => emits('update:modelValue', value),
})

return (_ctx: any,_cache: any) => {
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.showItemCount)
      ? (_openBlock(), _createBlock(TableItemCount, {
          key: 0,
          currentPage: page.value,
          itemsPerPage: __props.itemsPerPage,
          allElementsCount: __props.allElementsCount
        }, null, 8, ["currentPage", "itemsPerPage", "allElementsCount"]))
      : _createCommentVNode("", true),
    (__props.totalPage > 1)
      ? (_openBlock(), _createBlock(_component_v_pagination, {
          key: 1,
          modelValue: page.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((page).value = $event)),
          length: __props.totalPage,
          "total-visible": 7,
          "active-color": "teal",
          border: "",
          rounded: "lg"
        }, null, 8, ["modelValue", "length"]))
      : _createCommentVNode("", true)
  ]))
}
}

})